<template>
	<div class="auth-layout" :class="[rootClass, layoutClasses]">
		<!-- 左侧品牌区 (桌面端) -->
		<div class="brand-side">
			<div class="brand-top">
				<div class="brand-logo">
					<div class="brand-icon">
						<img src="/logo.png" :alt="appName" />
					</div>
					<div class="brand-text">
						<div class="brand-name">{{ appName }}</div>
						<div class="brand-desc">{{ brandDesc }}</div>
					</div>
				</div>
				<div class="brand-headline">{{ headline }}</div>
				<div class="brand-subtext">{{ subtext }}</div>
			</div>
			<!-- 预览插图 -->
			<div class="brand-preview">
				<slot name="preview"></slot>
			</div>
			<div class="brand-bottom">
				<div v-for="(badge, i) in badges" :key="i" class="brand-badge-row">
					<span class="brand-badge">{{ badge.label }}</span>
					<span class="brand-badge-text">{{ badge.text }}</span>
				</div>
			</div>
		</div>

		<!-- 右侧表单区 -->
		<div class="form-side">
			<div class="form-container">
				<!-- 移动端品牌卡片 -->
				<div v-if="!hideMobileBrandCard" class="mobile-brand-card">
					<div class="mobile-brand-row">
						<div class="mobile-brand-icon">
							<img src="/logo.png" :alt="appName" />
						</div>
						<div>
							<div class="mobile-brand-name">{{ appName }}</div>
							<div class="mobile-brand-desc">{{ mobileDesc }}</div>
						</div>
					</div>
					<slot name="mobile-extra"></slot>
				</div>
				<slot></slot>
			</div>
		</div>
		<slot name="extra"></slot>
	</div>
</template>

<script>
import shellIdentity from '../../utils/shellIdentity';

export default {
	name: 'AuthLayout',
	props: {
		rootClass: { type: String, default: '' },
		brandDesc: { type: String, default: '安全即时通讯' },
		headline: { type: String, required: true },
		subtext: { type: String, required: true },
		mobileDesc: { type: String, required: true },
		hideMobileBrandCard: { type: Boolean, default: false },
		badges: {
			type: Array,
			default: () => [
				{ label: '安全', text: '端到端加密通信，数据安全有保障' },
				{ label: '多端', text: '支持 Web、桌面端与移动端同步使用' }
			]
		}
	},
	computed: {
		appName() {
			return shellIdentity.buildShellIdentity('');
		},
		electronMode() {
			return Boolean(this.configStore && this.configStore.electronMode);
		},
		layoutClasses() {
			return {
				'auth-layout--electron': this.electronMode
			};
		}
	}
}
</script>

<style scoped lang="scss">
.auth-layout {
	width: 100%;
	height: 100%;
	display: flex;
	background: var(--im-background);
	box-sizing: border-box;
}

// 左侧品牌区
.brand-side {
	display: none;
	width: 44%;
	flex-direction: column;
	justify-content: space-between;
	border-right: 1px solid rgba(var(--im-black-rgb), 0.08);
	background-image: url('data:image/svg+xml;base64,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');
	background-size: cover;
	background-position: center bottom;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: rgba(var(--im-primary-rgb), 0.72);
		z-index: 0;
	}

	[data-theme="dark"] & {
		&::before {
			background: rgba(10, 14, 26, 0.15);
		}
	}

	> * {
		position: relative;
		z-index: 1;
	}
	padding: 32px;

	@media (min-width: 1024px) {
		display: flex;
	}

	@keyframes brandFadeUp {
		from { opacity: 0; transform: translateY(18px); }
		to   { opacity: 1; transform: translateY(0); }
	}

	.brand-top {
		.brand-logo {
			display: inline-flex;
			align-items: center;
			gap: 10px;
			margin-bottom: 14px;
			animation: brandFadeUp 0.5s ease both;
			animation-delay: 0.1s;

			.brand-icon {
				width: 32px;
				height: 32px;

				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}

			.brand-text {
				.brand-name {
					font-size: 18px;
					font-weight: 600;
					line-height: 1.2;
					color: #fff;
				}
				.brand-desc {
					font-size: 14px;
					color: rgba(255, 255, 255, 0.75);
				}
			}
		}

		.brand-headline {
			max-width: 28rem;
			font-size: 28px;
			font-weight: 600;
			line-height: 1.1;
			letter-spacing: -0.02em;
			color: #fff;
			margin-bottom: 10px;
			animation: brandFadeUp 0.5s ease both;
			animation-delay: 0.22s;
		}

		.brand-subtext {
			max-width: 30rem;
			font-size: 13px;
			line-height: 1.55;
			color: rgba(255, 255, 255, 0.8);
			animation: brandFadeUp 0.5s ease both;
			animation-delay: 0.34s;
		}
	}

	.brand-preview {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 18px 0;
		animation: brandFadeUp 0.5s ease both;
		animation-delay: 0.46s;
	}

	.brand-bottom {
		display: grid;
		gap: 12px;
		font-size: 14px;
		animation: brandFadeUp 0.5s ease both;
		animation-delay: 0.58s;

		.brand-badge-row {
			display: flex;
			align-items: flex-start;
			gap: 12px;

			.brand-badge {
				display: inline-flex;
				align-items: center;
				padding: 2px 10px;
				border-radius: 9999px;
				font-size: 12px;
				font-weight: 500;
				background: rgba(255, 255, 255, 0.2);
				color: #fff;
				white-space: nowrap;
			}

			.brand-badge-text {
				color: rgba(255, 255, 255, 0.8);
			}
		}
	}
}

// 右侧表单区
.form-side {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 16px;
	overflow-y: auto;

	@media (min-width: 640px) {
		padding: 24px;
	}
}

.auth-layout--electron .form-side {
	align-items: flex-start;
	padding: 14px 16px 16px;
}

.form-container {
	width: 100%;
	max-width: 520px;
	margin: auto;
}

.auth-layout--electron .form-container {
	max-width: 420px;
}

// 移动端品牌卡片
.mobile-brand-card {
	margin-bottom: 12px;
	border-radius: 18px;
	border: 1px solid rgba(var(--im-black-rgb), 0.08);
	background: var(--im-card-bg-75);
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
	padding: 12px 14px;
	box-shadow: 0 1px 3px rgba(var(--im-black-rgb), 0.05);

	@media (min-width: 1024px) {
		display: none;
	}

	.mobile-brand-row {
		display: flex;
		align-items: center;
		gap: 10px;

		.mobile-brand-icon {
			width: 30px;
			height: 30px;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		.mobile-brand-name {
			font-size: 15px;
			font-weight: 600;
			color: var(--im-text-color);
		}

		.mobile-brand-desc {
			font-size: 12px;
			color: var(--im-text-color-light);
			line-height: 1.2;
		}
	}
}

.auth-layout--electron .mobile-brand-card {
	margin-bottom: 10px;
	padding: 10px 12px;
}

.auth-layout--electron ::v-deep .auth-card .card-header .card-desc {
	display: none;
}

@media (max-width: 767px) {
	.auth-layout ::v-deep .auth-card .card-header .card-desc {
		display: none;
	}
}

// tab 切换过渡
.tab-fade-enter-active,
.tab-fade-leave-active {
	transition: opacity 0.18s ease, transform 0.18s ease;
}
.tab-fade-enter {
	opacity: 0;
	transform: translateY(6px);
}
.tab-fade-leave-to {
	opacity: 0;
	transform: translateY(-6px);
}
</style>
